module.exports = __webpack_public_path__ + "static/media/inf_11og12.7afbfa74.mp3";